'use client';
import React from 'react';
import { CommentsActions } from '@store/client/comments/comments-actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/root-reducer';
import CommentsList from './sub-components/comments-list';
import InfiniteScrollLayout from '../../../components/infinit-scroll-layout';

const CommentsLayout = () => {
  const dispatch = useDispatch();
  const { list, currentPage, lastPage } = useSelector((state: RootState) => state.comments);

  const handleMessagesPagination = () => {
    dispatch(CommentsActions.getExtendedCommentsList());
  };

  return (
    <InfiniteScrollLayout
      next={handleMessagesPagination}
      hasMore={lastPage >= currentPage}
      length={list.length}
    >
      <CommentsList />
    </InfiniteScrollLayout>
  );
};

export default CommentsLayout;
